import { useMutation, useQueryClient } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { AddMetricToCollectionDto, FetchError, queryKeys, useAccessToken } from "src/http";

type Variables = {
  metricCollectionGuid: string;
  metricGuid: string;
  sortOrder: string;
};

const useAddMetricToCollectionRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function addMetricToCollectionRequest(variables: Variables) {
    const accessToken = await getAccessToken();
    const body: AddMetricToCollectionDto = {
      metricGuid: variables.metricGuid,
      sortOrder: variables.sortOrder,
    };

    const response = await fetch(`${configuration.apiRootUrl}/metric-collections/${variables.metricCollectionGuid}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      method: "post",
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { addMetricToCollectionRequest };
};

const useAddMetricToCollection = () => {
  const { addMetricToCollectionRequest } = useAddMetricToCollectionRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addMetricToCollectionRequest,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.metrics.getMetricCollection(variables.metricCollectionGuid),
      });
    },
  });
};

export { useAddMetricToCollection };
